import logo from './logo.svg';
import './App.css';
import { useState, useEffect } from 'react';
import ConditionsPage from './pages/ConditionsPage';
import FormulairePage from './pages/FormulairePage';
import StatusPage from './pages/StatusPage';

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [currentPage, setCurrentPage] = useState('conditions');

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return (
      <div className="splash-screen">
        <div className="splash-content">
          <img src="/app-logo.png" alt="app logo" className="splash-logo" />
          <p className="splash-text">DEMANDE D'EQUIVALENCE</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {currentPage === 'conditions' && (
        <ConditionsPage onContinue={() => setCurrentPage('formulaire')} onShowDemand={() => setCurrentPage('status')} />
      )}
      {currentPage === 'formulaire' && (
        <FormulairePage onBack={() => setCurrentPage('conditions')} onShowDemand={() => setCurrentPage('status')} />
      )}
      {currentPage === 'status' && (
        <StatusPage onBack={() => setCurrentPage('conditions')} />
      )}
    </div>
  );
}

export default App;
